var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "label",
        {
          staticClass: "col-sm-3 font-weight-bold col-form-label",
          attrs: { for: _vm.id }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
          _vm.isRequired && !_vm.isDisabled ? _c("required-label") : _vm._e(),
          _vm._v(" "),
          _vm.info
            ? _c("font-awesome-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.info,
                    expression: "info"
                  }
                ],
                staticClass: "text-primary ml-1",
                attrs: { icon: ["fad", "info-circle"] }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isNew
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-success" }, [
                  _vm._v("Nieuw")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$v.selectedNummer.$invalid
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-danger" }, [
                  _vm._v("Ongeldig")
                ])
              ])
            : _vm.isDirty
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v("Aangepast")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.selectedNummer.prefix,
              expression: "selectedNummer.prefix",
              modifiers: { trim: true }
            }
          ],
          class: [
            _vm.$v.selectedNummer.prefix.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            type: "text",
            maxlength: "5",
            placeholder: _vm.labels.contact.comnummer.prefix,
            disabled: _vm.isDisabled == true
          },
          domProps: { value: _vm.selectedNummer.prefix },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.selectedNummer,
                  "prefix",
                  $event.target.value.trim()
                )
              },
              _vm.updateNummer
            ],
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.selectedNummer.nummer,
              expression: "selectedNummer.nummer",
              modifiers: { trim: true }
            }
          ],
          class: [
            _vm.$v.selectedNummer.nummer.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            type: "text",
            placeholder: _vm.labels.contact.comnummer.nummer,
            disabled: _vm.isDisabled == true
          },
          domProps: { value: _vm.selectedNummer.nummer },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.selectedNummer,
                  "nummer",
                  $event.target.value.trim()
                )
              },
              _vm.updateNummer
            ],
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c(
          "select",
          {
            class: [
              _vm.$v.selectedNummer.type.$invalid ? "is-invalid" : "",
              "form-control",
              "natio-select"
            ],
            attrs: {
              placeholder: _vm.labels.contact.comnummer.type,
              disabled: _vm.isDisabled == true
            },
            domProps: { value: _vm.value.type },
            on: {
              change: function($event) {
                return _vm.updateNummerType($event.target.value)
              }
            }
          },
          [
            _c(
              "option",
              {
                attrs: { value: "Domicilie" },
                domProps: {
                  selected: _vm.value.type == _vm.selectedNummer.type
                }
              },
              [_vm._v("\n          Domicilie\n        ")]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "Werk" },
                domProps: {
                  selected: _vm.value.type == _vm.selectedNummer.type
                }
              },
              [_vm._v("\n          Werk\n        ")]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "Mobiel" },
                domProps: {
                  selected: _vm.value.type == _vm.selectedNummer.type
                }
              },
              [_vm._v("\n          Mobiel\n        ")]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "Noodnummer" },
                domProps: {
                  selected: _vm.value.type == _vm.selectedNummer.type
                }
              },
              [_vm._v("\n          Noodnummer\n        ")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showDelete && !_vm.isDisabled
        ? _c(
            "div",
            { staticClass: "col-sm-1" },
            [
              !_vm.isNew
                ? _c("erase-button", {
                    attrs: { tooltipText: _vm.tooltipTextForNumber() },
                    on: { click: _vm.deletePhone }
                  })
                : _c("delete-button", {
                    attrs: { tooltipText: _vm.tooltipTextForNumber() },
                    on: { click: _vm.deletePhone }
                  })
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.selectedNummer.type == "Noodnummer"
      ? _c("div", { staticClass: "row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-3 font-weight-bold col-form-label",
              attrs: { for: _vm.opm }
            },
            [_vm._v("\n      Opmerking (naam en/of verwantschap)\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.selectedNummer.opm,
                  expression: "selectedNummer.opm",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              class: [
                _vm.$v.selectedNummer.opm.$invalid ? "is-invalid" : "",
                "form-control"
              ],
              attrs: { rows: "1", required: _vm.required },
              domProps: { value: _vm.selectedNummer.opm },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.selectedNummer,
                      "opm",
                      $event.target.value.trim()
                    )
                  },
                  _vm.updateNummer
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }